import axios from "axios";
import store from "../store";

class Google {

    async get_auth_url(scopes) {
        let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {

            // generate query params
            let params = new URLSearchParams();
            params.append("scopes", scopes);

            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/auth_url?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async connect(code) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            // generate query params
            let params = new URLSearchParams();
            params.append("code", code);

            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/connect?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async import_spreadsheet(table, spreadsheet_id, credential_name, range) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            // generate query params
            let params = new URLSearchParams();
            params.append("spreadsheet_id", spreadsheet_id);
            params.append("table", table);
            params.append("credential_name", credential_name);
            params.append("range", range);

            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/import_spreadsheet?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async update_sheet_from_ged(ged_file, spreadsheet_id, credential_name, range) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            axios
            .post(
                process.env.VUE_APP_SAAS_BACK + "/google/update/sheet/from_ged",
                {
                    credential_name: credential_name,
                    spreadsheet_id: spreadsheet_id,
                    ged_file: ged_file,
                    range: range
                },
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                console.log(error);
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async update_sheet_from_table(table, spreadsheet_id, credential_name, range) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            axios
            .post(
                process.env.VUE_APP_SAAS_BACK + "/google/update/sheet/from_table",
                {
                    credential_name: credential_name,
                    spreadsheet_id: spreadsheet_id,
                    table: table,
                    range: range
                },
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async create_sheet_from_ged(ged_file, credential_name, sheet_name) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            axios
            .post(
                process.env.VUE_APP_SAAS_BACK + "/google/create/sheet/from_ged",
                {
                    credential_name: credential_name,
                    ged_file: ged_file,
                    sheet_name: sheet_name
                },
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                console.log(error);
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async create_sheet_from_table(table, credential_name, sheet_name) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            axios
            .post(
                process.env.VUE_APP_SAAS_BACK + "/google/create/sheet/from_table",
                {
                    credential_name: credential_name,
                    table: table,
                    sheet_name: sheet_name
                },
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async send_token(code) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            // generate query params
            let params = new URLSearchParams();
            params.append("code", code);

            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/access_token?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async getAccounts()
    {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/accounts",
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    
    }

    async getDriveFiles(mimeType, credential_name, fileNameQuery)
    {
        let jwt = store.state.jwt;

        let params = new URLSearchParams();
        params.append("mime_type", mimeType);
        params.append("credential_name", credential_name);
        params.append("name_filter", fileNameQuery);

        return new Promise(function (resolve, reject) {
            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/drive/files?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    
    }

    async getSheets(spreadsheet_id, credential_name)
    {
        let jwt = store.state.jwt;

        let params = new URLSearchParams();
        params.append("spreadsheet_id", spreadsheet_id);
        params.append("credential_name", credential_name);

        return new Promise(function (resolve, reject) {
            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/spreadsheet/sheets?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async save_sheet_to_ged(spreadsheet_id, credential_name, range, file_name)
    {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            // generate query params
            let params = new URLSearchParams();
            params.append("spreadsheet_id", spreadsheet_id);
            params.append("file_name", file_name);
            params.append("credential_name", credential_name);
            params.append("range", range);

            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/import/sheet/ged?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }

    async get_sheet_values(spreadsheet_id, credential_name, range)
    {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {

            // generate query params
            let params = new URLSearchParams();
            params.append("spreadsheet_id", spreadsheet_id);
            params.append("credential_name", credential_name);
            params.append("range", range);

            axios
            .get(
                process.env.VUE_APP_SAAS_BACK + "/google/spreadsheet/raw?" + params.toString(),
                {
                    headers: { Authorization: "Bearer " + jwt },
                }
            )
            .then(function (response) {
                console.log(response);
                var data = response.data;
                resolve(data);
            })
            .catch(function (error) {
                console.log(error);
                reject({ name: error.response.status, message: error.response.data.msg });
            });
        });
    }
}

export default new Google();